import Vue from 'vue';
import TriggerContactsFetchingMutation from '@/apollo/mutations/TriggerContactsFetching.mutation';
// @ts-ignore
import LastContactsSyncedQuery from '~/components/partials/public-portfolio/apollo/LastContactsSynced.gql';
import type { MutationTriggerContactsFetchingArgs } from '~/types/graphql';

type PublicPortfolioContactsSyncData = {
  isOpen: boolean;
  currentUser: { lastContactsSyncedAt: string | null; lastContactsSyncError: string | null };
  contactsSynced: boolean;
  hasTriggeredContactsFetching: boolean;
};

export default Vue.extend({
  name: 'PublicPortfolioContactsSync',
  data(): PublicPortfolioContactsSyncData {
    return {
      currentUser: {
        lastContactsSyncedAt: null,
        lastContactsSyncError: null,
      },
      contactsSynced: false,
      hasTriggeredContactsFetching: false,
      isOpen: false,
    };
  },
  apollo: {
    currentUser: {
      query: LastContactsSyncedQuery,
      update(data) {
        const oldSyncedAt = this.currentUser.lastContactsSyncedAt;
        const newSyncedAt = data.currentUser.lastContactsSyncedAt;
        this.contactsSynced = !!oldSyncedAt && oldSyncedAt !== newSyncedAt;

        const error = this.hasTriggeredContactsFetching ? data.currentUser.lastContactsSyncError : '';
        data.currentUser.lastContactsSyncError = error;

        return data.currentUser;
      },
      skip(): boolean {
        return !this.isOwnPortfolio || !this.isOpen || this.contactsSynced;
      },
      result() {
        if (!this.hasTriggeredContactsFetching) {
          this.triggerContactsFetching();
        }
      },
    },
  },
  computed: {
    isOwnPortfolio(): boolean {
      return this.$auth.user?.slug === this.$route.params.slug;
    },
  },
  methods: {
    async triggerContactsFetching() {
      await this.$apollo.mutate<boolean, MutationTriggerContactsFetchingArgs>({
        mutation: TriggerContactsFetchingMutation,
        variables: {
          input: {},
        },
        update: () => {
          this.hasTriggeredContactsFetching = true;
          this.$apollo.queries.currentUser.startPolling(1000);
        },
      });
    },
  },
});
